import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaClock,
  FaArrowRight
} from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const [result, setResult] = useState("");

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    setResult("Sending...");

    const formData = new FormData(e.target);
    formData.append("access_key", "55404875-0dd0-468b-ab6d-655f3c2436b5");
    formData.append("subject", "Newsletter Subscription");
    formData.append("message", "New user subscribed to newsletter");

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData
      });

      const data = await response.json();

      if (data.success) {
        setResult("Subscribed successfully!");
        e.target.reset();
      } else {
        setResult("Subscription failed. Try again.");
      }
    } catch (error) {
      setResult("Network error. Please try later.");
    }
  };

  return (
    <footer className="footer">

      {/* Footer Top */}
      <div className="footer-top">
        <div className="container">
          <div className="footer-grid">

            {/* About */}
            <div className="footer-col">
              <div className="footer-logo">
                <div className='foterlogo'>
                  <img src="/img/logo.png" alt="logo" />
                </div>
              </div>
              <p className="footer-about">
                Net Nest Badminton Sports Club is a premier destination for badminton
                enthusiasts of all levels. We provide world-class facilities, expert
                coaching, and a vibrant community for players to grow and excel.
              </p>
              <div className="social-links">
                <a href="https://facebook.com" target="_blank" rel="noreferrer"><FaFacebookF /></a>
                <a href="https://twitter.com" target="_blank" rel="noreferrer"><FaTwitter /></a>
                <a href="https://instagram.com" target="_blank" rel="noreferrer"><FaInstagram /></a>
                <a href="https://youtube.com" target="_blank" rel="noreferrer"><FaYoutube /></a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-col">
              <h4>Quick Links</h4>
              <ul className="footer-links">
                <li><Link to="/"><FaArrowRight /> Home</Link></li>
                <li><Link to="/about"><FaArrowRight /> About Us</Link></li>
                <li><Link to="/Mission-Vision"><FaArrowRight /> Mission Vision</Link></li>
                <li><Link to="/services"><FaArrowRight /> Services</Link></li>
                <li><Link to="/staff"><FaArrowRight /> Our Coaches</Link></li>
                <li><Link to="/testimonials"><FaArrowRight /> Testimonials</Link></li>
                <li><Link to="/contact"><FaArrowRight /> Contact Us</Link></li>
              </ul>
            </div>

            {/* Services */}
            <div className="footer-col">
              <h4>Our Services</h4>
              <ul className="footer-links">
                <li><Link to="/court-rental"><FaArrowRight /> Court Rental</Link></li>
                <li><Link to="/training"><FaArrowRight /> Training Programs</Link></li>
                <li><Link to="/membership"><FaArrowRight /> Membership Plans</Link></li>
                <li><Link to="/Tournaments"><FaArrowRight /> Tournaments</Link></li>
                <li><Link to="/Equipment-Shop"><FaArrowRight /> Equipment Shop</Link></li>
                <li><Link to="/Private-Coaching"><FaArrowRight /> Private Coaching</Link></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="footer-col">
              <h4>Contact Info</h4>
              <ul className="contact-info">
                <li><FaMapMarkerAlt /> Sector 7, Sonipat, Haryana 131021</li>
                <li><FaPhone /> +91 9896251565</li>
                <li><FaEnvelope /> info@nnbsportsclub.com</li>
                <li><FaClock /> Mon - Sat: 6 AM - 10 PM</li>
              </ul>
            </div>

          </div>
        </div>
      </div>

      {/* Newsletter */}
      <div className="footer-newsletter">
        <div className="container">
          <div className="newsletter-content">
            <div className="newsletter-text">
              <h4>Subscribe to Our Newsletter</h4>
              <p>Get the latest news, updates, and offers.</p>
            </div>

            <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
              <input
                type="email"
                name="email"
                placeholder="Enter your email address"
                required
              />
              <button type="submit">Subscribe</button>
            </form>

            {result && <p className="newsletter-result">{result}</p>}
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Net Nest Badminton Sports Club. All Rights Reserved.</p>
          </div>
        </div>
      </div>

    </footer>
  );
};

export default Footer;
